import React, {useReducer} from 'react';

export const reducer = function(state, action) {
  // {console.log(state,action)}
  switch (action.type) {
    case 'click':
      return {...state, value: action.value};

    default:
      return state;
  }
};
const initialState = {value: 'previewmode'};
const CounterContext = React.createContext(initialState);
function CounterProvider(props) {
  // new
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    // new
    <CounterContext.Provider value={{state, dispatch}}>{props.children}</CounterContext.Provider>
  );
}

export {CounterContext, CounterProvider};
